import $ from 'jquery';
import { Component } from '../core/component';

export class ProjectListingLoadMore extends Component {
    constructor() {
        super();
        this.selector = '.js-paginate-load-more';
    }

    init() {
        /* eslint-disable no-unused-vars */
        this.$elements.each((index, element) => {
            $('.js-paginate-load-more').click(function (e) {
                e.preventDefault();
                $(this).fadeOut(100);
                const params = window.location.search;
                const nextUrl = $(this).attr('href');
                const newUrl = nextUrl + params;

                const $listingItems = $('.tile-set__tiles-wrapper');
                const $loadMore = $(this);

                const onSuccess = function (data) {
                    const dataHtml = $.parseHTML(data);
                    const $newListingItems = $(dataHtml).filter('.tile-set__tiles-wrapper').html();
                    $($newListingItems).appendTo($listingItems);

                    // $listingItems.append($newListingItems.html());
                    const $newLoadMore = $(dataHtml).find('.js-paginate-load-more');
                    if ($newLoadMore.length) {
                        $loadMore.attr('href', $newLoadMore.attr('href'));
                    } else {
                        $loadMore.closest('.js-paginate-load-more-container').remove();
                    }
                    $loadMore.fadeIn(500);
                    $(window).trigger('resize').trigger('scroll');
                };
                $.ajax({
                    url: newUrl,
                    type: 'get',
                    success: onSuccess,
                    error() {
                        // console.log('Error' + err);
                    },
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/project-listing-load-more.js